import { render, staticRenderFns } from "./shipinpaishe.vue?vue&type=template&id=dade7096&scoped=true"
import script from "./shipinpaishe.vue?vue&type=script&lang=js"
export * from "./shipinpaishe.vue?vue&type=script&lang=js"
import style0 from "./shipinpaishe.vue?vue&type=style&index=0&id=dade7096&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dade7096",
  null
  
)

export default component.exports